<template>
  <div>
    <b-card no-body>
      <!-- Head -->
      <table-header
        search
        search-placeholder="Cari di sini"
        search-action="setting/getSettingsList"
      >
        <template #action>
          <b-button
            v-if="canAccess('manage', 'Faq')"
            variant="primary"
            :to="{ name: 'faq-create'}"
          >
            + Buat FAQ
          </b-button>
        </template>
      </table-header>
      <!-- Body -->
      <b-skeleton-table
        v-if="isLoading"
        :rows="5"
        :columns="4"
      />
      <b-table
        v-else
        ref="refUserListTable"
        :items="faqs.data"
        responsive
        :fields="tableFields"
        primary-key="id"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        class="position-relative mh-160"
      >

        <!-- Column: Pertanyaan -->
        <template #cell(question)="data">
          <!-- eslint-disable vue/no-v-html -->
          <div v-html="data.item.question" />
        </template>

        <!-- Column: Jawaban -->
        <template #cell(answer)="data">
          <!-- eslint-disable vue/no-v-html -->
          <div
            class="min-content-html"
            v-html="data.item.answer"
          />
        </template>

        <!-- Column: Kategori -->
        <template #cell(category)="data">
          {{ data.item.category ? data.item.category.name : '-' }}
        </template>

        <!-- Column: Active -->
        <template #cell(active)="data">
          <b-form-checkbox
            :checked="!!data.item.is_active"
            name="check-button"
            switch
            inline
            @change="activated(data.item, $event, 'active')"
          />
        </template>

        <!-- Column: Highlight -->
        <template #cell(highlight)="data">
          <b-form-checkbox
            v-if="canAccess('manage', 'Faq')"
            :checked="!!data.item.is_highlighted"
            name="check-button"
            switch
            inline
            @change="activated(data.item, $event, 'highlight')"
          />
          <div v-else>
            <b-badge
              v-if="!!data.item.is_highlighted"
              variant="light-primary"
              class="mb-1 mr-1"
            >
              Highlight
            </b-badge>
          </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <!-- Dropdown -->
            <table-action
              :actions="tableAction"
              :data="data"
            />
          </div>
        </template>

      </b-table>
      <!-- Footer -->
      <div class="mx-2 mb-2">
        <pagination
          :data="faqs.meta"
          action="faq/getFaqs"
        />
      </div>
    </b-card>

    <b-modal
      id="modal-faq-detail"
      title="Detail FAQ"
      hide-footer
    >
      <div v-if="faqDetail">
        <h5>Pertanyaan</h5>
        <blockquote class="blockquote pl-1 border-left-primary border-left-3">
          <!-- eslint-disable vue/no-v-html -->
          <p v-html="faqDetail.question" />
        </blockquote>

        <hr class="my-2">

        <h5>Jawaban</h5>
        <blockquote class="blockquote pl-1 border-left-primary border-left-3">
          <!-- eslint-disable vue/no-v-html -->
          <p v-html="faqDetail.answer" />
        </blockquote>
      </div>
    </b-modal>

    <b-modal
      v-if="canAccess('manage', 'Faq')"
      id="modal-delete"
      title="Apakah anda yakin"
      @hidden="deletedData = ''"
    >
      Ingin Menghapus FAQ ini?
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-secondary"
          :disabled="isDeleting"
          @click="cancel()"
        >
          Batalkan
        </b-button>
        <b-button
          variant="danger"
          :disabled="isDeleting"
          @click.prevent="handleDelete"
        >
          <b-spinner
            v-if="isDeleting"
            small
            label="Spinning"
          />
          {{ isDeleting ? 'Menghapus' : 'Ya, Hapus' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Ripple from 'vue-ripple-directive'
import {
  BSkeletonTable,
  BButton,
  BCard,
  BTable,
  VBTooltip,
  BModal,
  BFormCheckbox,
} from 'bootstrap-vue'
import Pagination from '@/layouts/components/custom/Pagination.vue'
import TableHeader from '@/layouts/components/custom/TableHeader.vue'
import TableAction from '@/layouts/components/custom/TableAction.vue'

export default {
  components: {
    BButton,
    BSkeletonTable,
    BCard,
    BTable,
    BModal,
    BFormCheckbox,
    Pagination,
    TableHeader,
    TableAction,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      tableFields: [
        { key: 'question', label: 'Pertanyaan' },
        { key: 'answer', label: 'Jawaban' },
        { key: 'category', label: 'Kategori' },
        { key: 'active', label: 'Aktif' },
        { key: 'highlight', label: 'Highlight' },
        { key: 'actions', label: '' },
      ],
      isPending: false,
      isDeleting: false,
      faqDetail: '',
      deletedData: '',
    }
  },
  computed: {
    ...mapState('faq', ['faqs', 'isLoading']),
    query() {
      return this.$route.query
    },
    tableAction() {
      return [
        {
          access: null,
          to: null,
          action: data => { this.showDetailModal(data) },
          icon: 'EyeIcon',
          title: 'Detail',
        },
        {
          access: null,
          to: 'faq-edit|id:id',
          action: '',
          icon: 'EditIcon',
          title: 'Edit',
        },
        {
          access: null,
          to: null,
          action: data => { this.deleteConfirmation(data.id) },
          icon: 'TrashIcon',
          title: 'Hapus',
        },
      ]
    },
  },
  async created() {
    await this.getFaqs(this.query)
  },
  methods: {
    ...mapActions('faq', ['getFaqs', 'deleteFaq', 'updateStatus']),
    deleteConfirmation(value) {
      this.$bvModal.show('modal-delete')
      this.deletedData = value
    },
    async handleDelete() {
      this.isDeleting = true
      await this.deleteFaq({ faqId: this.deletedData })
      this.isDeleting = false
      this.$bvModal.hide('modal-delete')
    },
    showDetailModal(item) {
      this.faqDetail = item
      this.$bvModal.show('modal-faq-detail')
    },
    activated(value, $event, element) {
      const dataForm = value

      if (dataForm.category) {
        dataForm.faq_category_id = dataForm.category.id
      } else {
        dataForm.faq_category_id = null
      }

      this.updateStatus({
        faqId: value.id, data: value, element, value: $event,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.min-content-html {
  max-height: 25px;
  overflow: hidden;
}
</style>
